<template>
  <div>
    <!-- 密码验证对话框 -->
    <el-dialog
      :visible.sync="showPasswordDialog"
      title="排班系统验证"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      show-cancel-button
      :before-close="handleClose"
      width="380px"
    >
      <div class="password-tip">
        <i class="el-icon-lock"></i>
        <span>访问排班系统需要密码验证</span>
      </div>
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        size="medium"
        @submit.native.prevent
      >
        <el-form-item prop="password">
          <el-input
            v-model="passwordForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
            auto-complete="off"
            @keyup.enter.native="verifyPassword"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goBack">返回</el-button>
        <el-button type="primary" @click="verifyPassword">确定</el-button>
      </span>
    </el-dialog>

    <!-- 主体内容（验证后才显示） -->
    <div v-show="isAuthenticated" class="container">
    <el-card style="min-width: 70%">
      <el-table
        :data="resData"
        :header-cell-style="headerOne"
        :cell-style="cellStyleRes"
        border
        stripe
      >
        <el-table-column prop="model" label="模块" width="150">
          <template slot-scope="{ row }">
            <div style="font-weight: bold">{{ row.modelTime }}</div>
            <div style="font-weight: bold">{{ row.modelText }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(weeks, index) in weekSys"
          :key="weeks.value"
          :prop="weeks.value"
          :label="weeks.name"
          min-width="225px"
        >
          <template slot="header">
            <div>{{ `${weeks.weekTime}（${weeks.name}）` }}</div>
            <div>{{ `负责人：${chargeSys[index].name}` }}</div>
            <div>{{ `${chargeSys[index].phone}` }}</div>
          </template>
          <template slot-scope="{ row, $index }">
            <div v-if="row.model === '撰稿人'">
              <el-select
                v-model="row[weeks.value]"
                size="small"
                @change="changeWrite($event, weeks.value)"
              >
                <el-option
                  v-for="item in getCurWriteOption(weeks.value)"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                  :disabled="compareFun(item.name, row)"
                >
                  <span
                    v-if="compareFun(item.name, row)"
                    style="float: left; color: #409eff"
                    >{{ item.name }}</span
                  >
                  <span v-else style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 12px">{{
                    item.writeTimes
                  }}</span>
                </el-option>
              </el-select>
            </div>
            <div v-else>
              <el-select
                v-model="row[weeks.value]"
                size="small"
                multiple
                :multiple-limit="2"
                filterable
                @visible-change="handleChange"
                @change="handleChange(true)"
              >
                <el-option
                  v-for="item in getCurOption($index, weeks.value)"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  <span
                    v-if="getscheduleTimes(item, row)"
                    style="float: left; color: blue"
                    >{{ item }}</span
                  >
                  <span v-else style="float: left">{{ item }}</span>
                  <span style="float: right; color: #8492a6; font-size: 12px">{{
                    userData.find((v) => v.name === item).scheduleTimes
                  }}</span>
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div>
        <span style="float: right">
          <el-button
            type="primary"
            icon="el-icon-refresh"
            @click="resetSchedule"
            size="mini"
            style="margin: 10px"
            >清空排班</el-button
          >
          <el-button
            type="primary"
            @click="writeSchedule"
            size="mini"
            style="margin: 10px"
            >生成撰稿①</el-button
          >
          <el-button
            type="primary"
            @click="randomSchedule"
            size="mini"
            style="margin: 10px"
            >撰稿后排班②</el-button
          >
          <el-button
            type="primary"
            @click="scheduleAll"
            size="mini"
            style="margin: 10px"
            >一键排班</el-button
          >
          <el-button
            type="success"
            icon="el-icon-download"
            @click="exportToExcel"
            size="mini"
            style="margin: 10px"
            >导出排班表</el-button
          >
        </span>

        <span style="float: left; height: 50px">
          <el-form
            :model="formData"
            size="mini"
            :inline="true"
            label-width="80px"
            :show-message="false"
          >
            <el-form-item>
              <el-input
                v-model="formData.name"
                placeholder="请输入查找姓名"
                :showMessage="false"
                style="margin: 10px; width: 170px"
              >
                <el-button
                  slot="append"
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="getAllAnnouncer(false)"
                />
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="mini"
                @click="openAddDialog"
                style="margin: 10px"
                icon="el-icon-plus"
                >新增广播员</el-button
              >
            </el-form-item>
          </el-form>
        </span>
      </div>

      <el-table
        :data="userData"
        :header-cell-style="{ 'text-align': 'center' }"
        height="550px"
        :loading="tableLoading"
        :cell-style="cellStyleUser"
        border
        stripe
      >
        <el-table-column prop="action" label="操作" width="120px">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              @click="openEditDialog(row)"
              >修改</el-button
            >
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              style="color: red"
              @click="deleteAnnouncer(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="isWrite" label="是否写稿" min-width="95px" sortable>
          <template slot-scope="{ row }">
            <el-checkbox v-model="row.isWrite" :true-label="1" :false-label="0" />
          </template>
        </el-table-column>
        <el-table-column prop="writeTimes" label="写稿次数" min-width="95px" sortable>
          <template slot-scope="{ row }">
            <span>{{ row.writeTimes }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isSchedule" label="是否排班" min-width="95px" sortable>
          <template slot-scope="{ row }">
          <el-checkbox v-model="row.isSchedule" :true-label="1" :false-label="0" />
          </template>
        </el-table-column>
        <el-table-column prop="scheduleTimes" label="排班次数" min-width="95px" sortable>
          <template slot-scope="{ row }">
            <span>{{ row.scheduleTimes }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100px"/>
        <el-table-column
          prop="timeData"
          label="时间段"
          min-width="220px"
          :filters="[{ text: '上午', value: '上午' }, { text: '中午', value: '中午' }, { text: '下午', value: '下午' }]"
          :filter-method="filterTimeData"
        >
          <template slot-scope="{ row }">
            <el-checkbox-group v-model="row.timeData" size="mini">
              <el-checkbox-button
                v-for="item in timeSys"
                :label="item.name"
                :key="item.name"
                >{{ item.name }}</el-checkbox-button
              >
            </el-checkbox-group>
          </template>
        </el-table-column>
        <el-table-column
          prop="weekData"
          label="周次"
          min-width="350px"
          :filters="[{ text: '周一', value: '周一' }, { text: '周二', value: '周二' }, { text: '周三', value: '周三' }, { text: '周四', value: '周四' }, { text: '周五', value: '周五' }]"
          :filter-method="filterWeekData"
        >
          <template slot-scope="{ row }">
            <el-checkbox-group v-model="row.weekData" size="mini">
              <el-checkbox-button
                v-for="item in weekSys"
                :label="item.name"
                :key="item.name"
                >{{ item.name }}</el-checkbox-button
              >
            </el-checkbox-group>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="activeStartDate"
          label="有效日期始"
          width="100px"
          sortable
        />
        <el-table-column
          prop="activeEndDate"
          label="有效日期止"
          width="100px"
          sortable
        /> -->
      </el-table>
    </el-card>

    <!-- 新增 / 修改 dialog -->
    <el-dialog
      :visible.sync="addVisible"
      :title="addType === 'add' ? '新 建' : '修 改'"
      width="500px"
      center
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addRules"
        size="mini"
        label-width="80px"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入 姓名"
            class="inputwidth"
          />
        </el-form-item>
        <el-form-item label="时间段" prop="timeData">
          <el-select
            v-model="addForm.timeData"
            multiple
            placeholder="请选择 时间段"
            class="inputwidth"
            clearable
          >
            <el-option
              v-for="item in timeSys"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="周次" prop="weekData">
          <el-select
            v-model="addForm.weekData"
            multiple
            placeholder="请选择 周次"
            class="inputwidth"
            clearable
          >
            <el-option
              v-for="item in weekSys"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否写稿" prop="isWrite">
          <el-switch v-model="addForm.isWrite" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="写稿次数" prop="writeTimes">
          <el-input
            v-model="addForm.writeTimes"
            placeholder="请输入 写稿次数"
            class="inputwidth"
          />
        </el-form-item>
        <el-form-item label="是否排班" prop="isSchedule">
          <el-switch v-model="addForm.isSchedule" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <!-- <el-form-item label="有效日期" prop="activeTime">
          <el-date-picker
            v-model="activeTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            class="inputwidth"
          />
        </el-form-item> -->

        <!-- <el-form-item label="姓名" prop="scheduleTimes">
          <el-input v-model="addForm.scheduleTimes" placeholder="请输入 姓名" />
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="confirmFun"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  readScheduleData,
  addScheduleData,
  delScheduleData,
  updateScheduleData,
} from "@/api/scheduleView.js";
import * as ExcelJS from "exceljs";
import dayjs from "dayjs";
export default {
  name: "ScheduleView",
  data() {
    return {
      isAuthenticated: false,
      showPasswordDialog: true,
      passwordForm: {
        password: ''
      },
      passwordRules: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      schedulePassword: '123456',
      timeSys: [
        { name: "上午", value: "morning" },
        { name: "中午", value: "noon" },
        { name: "下午", value: "afternoon" },
      ],
      weekSys: [
        { name: "周一", value: "Monday", weekTime: "7月12日", weekTitle: '7.12' },
        { name: "周二", value: "Tuesday", weekTime: "7月12日", weekTitle: '7.12' },
        { name: "周三", value: "Wednesday", weekTime: "7月12日", weekTitle: '7.12' },
        { name: "周四", value: "Thursday", weekTime: "7月12日", weekTitle: '7.12' },
        { name: "周五", value: "Friday", weekTime: "7月12日", weekTitle: '7.12' },
      ],
      chargeSys: [
        { name: "朱登宇", phone: "16675685785" },
        { name: "任盈盈", phone: "16626259875" },
        { name: "庄开媛", phone: "16675688037" },
        { name: "马丹", phone: "18434308779" },
        { name: "陈喆莹", phone: "16626295812" },
      ],
      noJoin: false,
      userData: [],
      resData: [
        {
          model: "撰稿人",
          modelTime: "",
          modelText: "撰稿人",
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
        },
        {
          model: "8:10——8:30 快乐工作",
          modelTime: "8:10——8:30",
          modelText: "快乐工作",
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
        },
        {
          model: "11:45——12:15 新闻速递",
          modelTime: "11:45——12:15",
          modelText: "新闻速递",
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
        },
        {
          model: "17:30——18:00 愉快生活",
          modelTime: "17:30——18:00",
          modelText: "愉快生活",
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
        },
      ],
      WriteOption: [],
      scheduleOption: {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
      },
      timeOption: {
        morning: [],
        noon: [],
        afternoon: [],
      },
      formData: {
        name: "",
      },
      // activeTime: [],
      addForm: {
        name: "",
        timeData: ["上午", "中午", "下午"],
        weekData: ["周一", "周二", "周三", "周四", "周五"],
        isWrite: 1,
        isSchedule: 1,
        writeTimes: 0,
        scheduleTimes: 0,
        // activeStartDate: "",
        // activeEndDate: "",
      },
      addRules: {
        name: [{ required: true, message: "请输入 姓名", trigger: "change" }],
        timeData: [
          {
            required: true,
            type: "array",
            message: "请输入 时间段",
            trigger: "change",
          },
        ],
        weekData: [
          {
            required: true,
            type: "array",
            message: "请输入 周次",
            trigger: "change",
          },
        ],
        writeTimes: [
          { required: true, message: "请输入 写稿次数", trigger: "change" },
        ],
        // activeTime: [
        //   {
        //     required: true,
        //     message: "请输入 有效日期",
        //     trigger: "change",
        //     validator: (_rule, _value, callback) => {
        //       if (this.activeTime.length <= 0) {
        //         callback("请输入 有效日期");
        //       } else {
        //         callback();
        //       }
        //     },
        //   },
        // ],
      },
      addVisible: false,
      addType: "add",
      tableLoading: false,
    };
  },
  created() {
    // 检查本地存储的验证状态
    const auth = localStorage.getItem('schedule_auth');
    if (auth === 'true') {
      this.isAuthenticated = true;
      this.showPasswordDialog = false;
      this.loadData();
    }
  },
  methods: {
    // 验证密码
    verifyPassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          if (this.passwordForm.password === this.schedulePassword) {
            this.isAuthenticated = true;
            this.showPasswordDialog = false;
            localStorage.setItem('schedule_auth', 'true');
            this.$message.success('验证成功');
            this.loadData();
          } else {
            this.$message.error('密码错误，请重试');
            this.passwordForm.password = '';
          }
        }
      });
    },
    // 返回上一页
    goBack() {
      this.$router.push('/');
    },
    // 关闭对话框
    handleClose(done) {
      this.$confirm('未验证将无法使用排班功能，确定返回？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '继续验证',
        type: 'warning'
      }).then(() => {
        this.$router.push('/');
      }).catch(() => {
        this.passwordForm.password = '';
      });
    },
    // 加载数据
    loadData() {
      this.getTime();
      this.getAllAnnouncer(true);
    },
    filterTimeData(value, row) {
      return row.timeData.includes(value);
    },
    filterWeekData(value, row) {
      return row.weekData.includes(value);
    },
    getTime() {
      const currentDayOfWeek = dayjs().day(); // 今天星期几（0=周日，1=周一 ... 6=周六）
      // 下周一距离今天的天数
      const daysUntilNextMonday = (8 - currentDayOfWeek) % 7 || 7;
      this.weekSys.map((v, index) => {
        const date = dayjs().add(daysUntilNextMonday + index, 'day');
        v.weekTime = date.format("M月D日");
        v.weekTitle = date.format("M.D");
      })
    },
    // 获取广播员数据
    getAllAnnouncer(isAll) {
      let obj = {};
      if (this.formData.name && !isAll) {
        obj = {
          name: this.formData.name,
        };
      }
      this.tableLoading = true;
      readScheduleData(obj)
        .then((res) => {
          const { result, msg } = res.data;
          if (result) {
            this.userData = res.data.data;
            console.log('userData: ', JSON.parse(JSON.stringify(this.userData)));
          } else {
            this.$message.error(msg);
          }
        })
        .finally(() => {
          this.resetSchedule() // 清空排班
          this.tableLoading = false;
        });
    },
    initAddForm() {
      return {
        name: "",
        timeData: ["上午", "中午", "下午"],
        weekData: ["周一", "周二", "周三", "周四", "周五"],
        isWrite: 1,
        isSchedule: 1,
        writeTimes: 0,
        scheduleTimes: 0,
      };
    },
    // getNextWeekDays() {
    //   let days = [];
    //   let today = dayjs();
    //   // 找到本周的星期日(这里dayjs的weekday索引从0开始, 0是周日)
    //   let currentWeekSunday = today.subtract(today.day(), "days");
    //   // 下周一就是本周日之后的第一天
    //   let nextMonday = currentWeekSunday.add(1, "weekData").add(1, "day");
    //   days.push(nextMonday.add(0, "day").format("YYYY-MM-DD"));
    //   days.push(nextMonday.add(4, "day").format("YYYY-MM-DD"));
    //   return days;
    // },
    openAddDialog() {
      this.addVisible = true;
      this.addType = "add";
      this.addForm = this.initAddForm();
      // this.activeTime = this.getNextWeekDays();
      // console.log("this.activeTime: ", this.activeTime);
    },
    openEditDialog(row) {
      this.addVisible = true;
      this.addType = "edit";
      this.addForm = { ...row };
    },
    confirmFun() {
      this.$refs["addForm"].validate(async (valid) => {
        if (valid) {
          if (this.addType === "add") {
            this.addAnnouncer();
          } else {
            this.updateAnnouncer();
          }
        }
      });
    },
    addAnnouncer() {
      // let activeStartDate = "";
      // let activeEndDate = "";
      // if (this.activeTime.length > 0) {
      //   activeStartDate = this.activeTime[0];
      //   activeEndDate = this.activeTime[1];
      // }
      const obj = {
        ...this.addForm,
        // activeStartDate,
        // activeEndDate,
      };
      this.tableLoading = true;
      addScheduleData(obj)
        .then((res) => {
          const { result, msg } = res.data;
          if (result) {
            this.$message.success("新增成功!");
            this.addVisible = false;
            this.getAllAnnouncer(true);
          } else {
            this.$message.error(msg);
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 保存广播员
    updateAnnouncer() {
      // let activeStartDate = "";
      // let activeEndDate = "";
      // if (this.activeTime.length > 0) {
      //   activeStartDate = this.activeTime[0];
      //   activeEndDate = this.activeTime[1];
      // }
      const obj = {
        id: this.addForm.id,
        ...this.addForm,
        // activeStartDate,
        // activeEndDate,
      };
      this.tableLoading = true;
      updateScheduleData(obj)
        .then((res) => {
          const { result, msg } = res.data;
          if (result) {
            this.$message.success("更新成功!");
            this.addVisible = false;
            this.getAllAnnouncer(true);
          } else {
            this.$message.error(msg);
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    deleteAnnouncer(row) {
      this.$confirm(`是否确定删除 ${row.name}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const obj = {
            id: row.id,
            name: row.name,
          };
          this.tableLoading = true;
          delScheduleData(obj)
            .then((res) => {
              const { result, msg } = res.data;
              if (result) {
                this.$message.success("删除成功！");
                this.getAllAnnouncer(true);
              } else {
                this.$message.error(msg);
              }
            })
            .finally(() => {
              this.tableLoading = false;
            });
        })
        .catch(() => {});
    },
    // 导出excel
    async exportToExcel() {
      try {
        // 创建一个新的工作簿
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Schedule");
        // 构建表头标题
        const headerTitle = ["格力之声广播站播音员排班表"];
        const headerTitleRow = worksheet.addRow(headerTitle);

        headerTitleRow.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF2CC" }, // 黄色
            bgColor: { argb: "FFF2CC" }, // 黄色
          };
          cell.font = { bold: true, size: 18 };
          cell.alignment = { horizontal: "center", vertical: "middle" }; // 水平垂直居中
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        })
        headerTitleRow.height = 36; // 设置行高

        worksheet.mergeCells('A1:F1'); // 合并A1:F1

        let header = ['模块']
        this.weekSys.forEach((weeks, index) => {
          header.push(`${weeks.weekTime}（${weeks.name}） \n 负责人：${this.chargeSys[index].name} \n ${this.chargeSys[index].phone}`)
        })
        const headerRow = worksheet.addRow(header);
        // 设置表头样式（黄色背景）
        headerRow.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF00" }, // 黄色
            bgColor: { argb: "FFFF00" }, // 黄色
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        });
        headerRow.height = 46; // 设置行高

        // 构建数据行
        this.resData.forEach((item) => {
          const row = worksheet.addRow([
            item.model === "撰稿人" ? item.model : `${item.modelTime} \n ${item.modelText}`,
            item.model === "撰稿人" ? item.Monday : item.Monday.join("、") || "", // 如果是空数组则显示为空字符串
            item.model === "撰稿人" ? item.Tuesday : item.Tuesday.join("、") || "",
            item.model === "撰稿人" ? item.Wednesday : item.Wednesday.join("、") || "",
            item.model === "撰稿人" ? item.Thursday : item.Thursday.join("、") || "",
            item.model === "撰稿人" ? item.Friday : item.Friday.join("、") || "",
          ]);

          // 设置其他单元格的边框
          row.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
            cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            // 第一列加粗
            if (colNumber === 1) {
              cell.font = { bold: true };
            }
          });
          row.height = 40;
        });

        // 获取第3行
        const firstDataRow = worksheet.getRow(3);
        for (let i = 1; i <= 6; i++) { // 只修改前五列
          const cell = firstDataRow.getCell(i);
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "BDD7EE" }, // 蓝色
          };
          cell.font = { bold: true };
          firstDataRow.height = 30;
        }
        
        // 构建结尾
        const endTitle = ["备注：所有播音员需在播报时段前15分钟到达广播室。"];
        const endTitleRow = worksheet.addRow(endTitle);
        worksheet.mergeCells('A7:F7'); // 合并A7:F7
        
        endTitleRow.eachCell((cell) => {
          cell.fill = { type: "pattern", pattern: "solid", };
          cell.font = { bold: true, size: 14 };
          cell.alignment = { horizontal: "center", vertical: "middle" }; // 水平垂直居中
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        })
        endTitleRow.height = 40; // 设置行高

        // 自动调整列宽
        worksheet.columns.forEach((column) => {
          column.width = 20; // 设置固定宽度
        });

        // 生成文件名
        const filename = `【${this.weekSys[0].weekTitle}-${this.weekSys[4].weekTitle}】格力之声广播排班表.xlsx`;

        // 将工作簿保存为文件并触发下载
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Failed to export to Excel:", error);
      }
    },
    // 写稿人一键赋值
    writeSchedule() {
      this.resetSchedule()
      // 获取可以写稿的人员
      const canWrite = this.userData.filter((item) => item.isWrite === 1);

      // 按写稿次数排序
      const writeList = canWrite
        .filter((item) => item.isSchedule === 1) // 必须排班才撰稿
        .sort(() => Math.random() - 0.5) // 随机排列
        // .sort((a, b) => a.writeTimes - b.writeTimes) // 升序排列
        .map((v) => v.name); // 获取姓名

      // 写稿人赋值
      this.weekSys.forEach((weeks1, index) => {
        if (weeks1.value) {
          this.resData[0][weeks1.value] = writeList[index];
          this.changeWrite(writeList[index], weeks1.value);
        }
      });
      this.handleChange(true) // 刷新排班次数
    },
    resetSchedule() {
      if (this.userData && this.userData.length === 0) {
        this.$message.warning("请添加广播员后排班");
        return;
      }
      // 重置排班表
      this.resData.forEach((row) => {
        this.weekSys.forEach((weekData) => {
          if (row.model === "撰稿人") {
            row[weekData.value] = "";
          } else {
            row[weekData.value] = [];
          }
        });
      });

      // 获取可以写稿的人员
      const canWrite = this.userData.filter((item) => item.isWrite === 1);
      this.WriteOption = canWrite.sort((a, b) => a.writeTimes - b.writeTimes); // 升序

      // 获取可以排班的人员
      const canSchedule = this.userData.filter((item) => item.isSchedule === 1);

      // 按排班次数排序
      // const scheduleList = canSchedule.sort(
      //   (a, b) => a.scheduleTimes - b.scheduleTimes
      // );

      for (const times of this.timeSys) {
        this.timeOption[times.value] = canSchedule
          .filter((v) => v.timeData.includes(times.name))
          .map((v) => v.name);
      }
      for (const weeks of this.weekSys) {
        this.scheduleOption[weeks.value] = canSchedule
          .filter((v) => v.weekData.includes(weeks.name))
          .map((v) => v.name);
      }
      this.handleChange(true) // 刷新排班次数
    },
    compareFun(name, row) {
      return (
        name === row.Monday ||
        name === row.Tuesday ||
        name === row.Wednesday ||
        name === row.Thursday ||
        name === row.Friday
      );
    },
    /**
     * 获取当前撰稿人option TODO
     * @param flag 'Monday'
     */
    getCurWriteOption(flag) {
      return this.WriteOption.filter((v) =>
        this.scheduleOption[flag].includes(v.name)
      );
    },
    /**
     * 获取当前option
     * @param index 1上午 2中午 3下午
     * @param flag 'Monday'
     */
    getCurOption(index, flag) {
      let timeStr = "";
      if (index === 1) {
        timeStr = "morning";
      } else if (index === 2) {
        timeStr = "noon";
      } else if (index === 3) {
        timeStr = "afternoon";
      }
      return this.timeOption[timeStr].filter((item) =>
        this.scheduleOption[flag].includes(item)
      );
    },
    // 获取排期次数
    getscheduleTimes(name, row) {
      return (
        name === row.Monday ||
        name === row.Tuesday ||
        name === row.Wednesday ||
        name === row.Thursday ||
        name === row.Friday
      );
    },
    /**
     * 撰稿人 切换
     * @param val '张三'
     * @param flag 'Monday'
     */
    changeWrite(val, flag) {
      const hasIndex = [];
      let indexx = 0;
      Object.values(this.timeOption).forEach((v) => {
        indexx += 1;
        if (v.includes(val)) {
          hasIndex.push(indexx);
        }
      });
      const resIndex = hasIndex.sort(() => Math.random() - 0.5)[0]; // 随机排列
      this.resData.map((v) => {
        if (v.model !== "撰稿人") {
          v[flag] = [];
        }
        return v;
      });
      this.resData[resIndex][flag] = [val];
    },
    // 一键排班
    scheduleAll() {
      this.writeSchedule()
      this.randomSchedule()
    },
    // 撰稿后排班
    randomSchedule() {
      this.resData.forEach((v, index) => {
        if (v.model !== "撰稿人") {
          this.weekSys.forEach((weekData) => {
            const curOption = this.getCurOption(index, weekData.value);
            const curOptionData = this.userData.filter((user) => {
              return curOption.indexOf(user.name) !== -1 && user.scheduleTimes === 0;
            })
            const randomOption = curOptionData.sort(() => Math.random() - 0.5) // 随机打乱
                                              .sort((a, b) => (a.timeData.length + a.weekData.length) - (b.timeData.length  + b.weekData.length)); // 按时间段+周次长度倒叙
            // console.log('randomOption: ',  JSON.parse(JSON.stringify(randomOption)));

            const weekFilter = v[weekData.value]
            
            if (randomOption && randomOption.length > 0) {
              if (weekFilter && weekFilter.length === 1) {
                const addOption = randomOption.filter(
                  (item) => item.name !== weekFilter[0]
                );
                if (addOption && addOption.length > 0) {
                  weekFilter.push(addOption[0].name);
                }
              } else if (weekFilter && weekFilter.length === 0) {
                weekFilter.push(randomOption[0].name);
                if (randomOption.length > 1) {
                  weekFilter.push(randomOption[1].name);
                }
              }
            }
            v[weekData.value] = weekFilter
            this.handleChange(true) // 刷新排班次数
          });
        }
      });
      this.handleChange(true) // 刷新排班次数
    },
    // 排班人改变
    handleChange(val) {
      if (val) {
        // 初始化 userData 的 scheduleTimes
        this.userData = this.userData.map((item) => ({
          ...item,
          scheduleTimes: 0,
        }));

        this.resData.forEach((v) => {
          if (v.model !== "撰稿人") {
            this.weekSys.forEach((weekData) => {
              this.userData.forEach((item) => {
                if (v[weekData.value].includes(item.name)) {
                  item.scheduleTimes += 1;
                }
              });
            });
          }
        });
      }
    },
    // 检查人员本周是否已经排班
    isScheduledThisWeek(name) {
      return this.resData.some((row) =>
        this.weekSys.some((weekData) => row[weekData.value].includes(name))
      );
    },

    // 检查人员本周是否已经写过稿
    hasWrittenThisWeek(name) {
      return this.weekSys.some((weekData) => this.resData[0][weekData.value] === name);
    },

    headerOne() {
      return {
        textAlign: "center",
        // backgroundColor: 'yellow',
        color: "black",
        height: "50px"
      };
    },
    cellStyleRes({row}) {
      if (row.model === '撰稿人') {
        return {
          textAlign: "center",
          // backgroundColor: "#BDD7EE",
          color: "black",
        };
      }
      return {
        textAlign: "center",
        color: "black",
      };
    },
    cellStyleUser({row, column}) {
      if (row.scheduleTimes === 0 && column.property === 'scheduleTimes') {
        return {
          textAlign: "center",
          backgroundColor: "#BDD7EE",
        }
      }
      return {
        textAlign: "center",
      };
    },
    headerTwo() {
      return {
        textAlign: "center",
        backgroundColor: "#BDD7EE",
        color: "black",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.password-tip {
  text-align: center;
  margin-bottom: 20px;
  color: #606266;

  i {
    font-size: 40px;
    color: #b45309;
    margin-bottom: 10px;
  }

  span {
    display: block;
    font-size: 14px;
  }
}

.container {
  display: flex;
  justify-content: space-evenly;

  ::v-deep .el-table .el-table__cell {
    padding: 2px 0;
  }
}

.inputwidth {
  width: 350px;
}

.el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: #464646;
  background-color: #EDF6FF;
  border-color: #8cc5ff;
}

.el-checkbox-button.is-disabled .el-checkbox-button__inner {
  color: #464646;
}

.el-input--small .el-input__inner {
  text-align: center;
}
.el-select .el-input__inner {
  text-align: center;
}
.el-form-item__label {
  color: #77787b;
  font-weight: bold;
}

.el-select .el-tag__close.el-icon-close {
  background-color: transparent;
}

.el-tag {
  font-size: 14px;

}
.el-tag.el-tag--info {
  background-color: #f2f8ff;
  border-color: #c3dfff;
  color: #409eff;

  .el-tag__close {
    color: #409eff;
  }
  
  .el-tag__close:hover {
    background-color: #409eff;
  }
}

.el-tag--mini {
  height: 25px;

  .el-icon-close {
    transform: scale(1);
  }
}
</style>
